<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="商品搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入商品名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
            <el-button type="primary" style="margin-left: 40px;" @click="addBtn">添加商品</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsName"
            label="商品名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="secKillPrice"
            label="秒杀价格">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsSpecPrice"
            label="售价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="stockNum"
            label="库存">
          </el-table-column>
          <el-table-column
            align="center"
            prop="buyLimit"
            label="购买限制">
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#CCCCCC"
                @change="switchChangeBtn(scope.row.id)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { querySecKillGoodsPageList, modelFunAddGoodsList, enableSecKillGoodsById, modelFunAddGoodsSave, modelFunGoodsDel  } from '@/api/seckill'
export default {
  name: 'GoodsList',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      querySecKillGoodsPageList({ goodsName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 添加商品页面 */
    addBtn () {
      this.$router.push('/goods_add')
    },
    /* 编辑 */
    editBtn (infoId) {
      this.$router.push({path: '/goods_add', query: {dataId: infoId}})
    },
    // 开启或禁用操作
    switchChangeBtn(infoId){
      let that = this
      enableSecKillGoodsById({ id: infoId}).then((res) => {
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {}
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        modelFunGoodsDel({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/seckill/GoodsList.vue